import client from './client';
import { getUserId, getAuthCode } from './authStorage';

/**
 * Fetch paginated sponsored posts for admin dashboard.
 */
export async function fetchSubscriptions(page = 1, perPage = 10) {
  const user_id   = getUserId();
  const auth_code = getAuthCode();

  const payload = { user_id, auth_code, page, per_page: perPage };
  const { data: res } = await client.post('/fetch_subscription.php', payload);

  if (res.status !== 200) {
    throw new Error(res.message || 'Failed to fetch subscriptions');
  }

  return {
    pagination: res.pagination,
    data: res.data
  };
}
